/* Lune landing-page controls. No React, storefront tracking, or review-service dependency. */
(() => {
  const root = document.querySelector('.reference-page');
  if (!root || root.dataset.luneInitialized) return;
  root.dataset.luneInitialized = 'true';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('[data-replo-carousel]').forEach(container => {
    const track = container.querySelector('[data-replo-part="slide-track"]');
    const slides = [...container.querySelectorAll('[data-replo-part="slide"]')];
    if (!track || !slides.length) return;
    const review = container.classList.contains('r-1g3816t');
    let index = 0, timer, touch = 0;
    function align() {
      const offset = slides[index].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      track.style.transform = `translate3d(-${offset}px, 0, 0)`;
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.setAttribute('data-is-active', String(i === index));
        if (review && i !== index) slide.querySelectorAll('video').forEach(v => v.pause());
      });
      container.querySelectorAll('[aria-label^="Go to slide"]').forEach(dot => {
        const active = Number(dot.getAttribute('aria-label').split(' ').pop()) - 1 === index;
        dot.setAttribute('aria-current', String(active));
        dot.classList.remove('r-1spti4', 'r-1tpo9ds');
        if (active) dot.classList.add(dot.classList.contains('r-q3fwt3') ? 'r-1spti4' : 'r-1tpo9ds');
      });
      container.querySelectorAll('.replo-sr-only').forEach(el => el.textContent = `Slide ${index + 1} of ${slides.length}`);
    }
    function move(next) {
      index = (next + slides.length) % slides.length;
      align();
      clearInterval(timer);
      if (!review && !reduced && slides.length > 1) timer = setInterval(() => move(index + 1), 5000);
    }
    container.querySelectorAll('[data-replo-part="nav-button"], [aria-label^="Go to slide"]').forEach(button => button.addEventListener('click', () => {
      const label = button.getAttribute('aria-label') || '';
      move(label.startsWith('Go to slide') ? Number(label.split(' ').pop()) - 1 : index + (button.dataset.direction === 'previous' ? -1 : 1));
    }));
    container.addEventListener('touchstart', e => touch = e.touches[0]?.clientX || 0, {passive: true});
    container.addEventListener('touchend', e => {
      const delta = touch - (e.changedTouches[0]?.clientX ?? touch);
      if (Math.abs(delta) > 40) move(index + (delta > 0 ? 1 : -1));
    }, {passive: true});
    new ResizeObserver(align).observe(container);
    move(0);
  });
  root.querySelectorAll('button[aria-expanded][aria-controls]').forEach(button => {
    const answer = document.getElementById(button.getAttribute('aria-controls'));
    if (!answer) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open)); answer.hidden = !open;
    });
  });
  root.querySelectorAll('video').forEach(video => {
    if (video.autoplay) { video.muted = true; video.playsInline = true; video.play().catch(() => {}); }
    video.addEventListener('click', () => { if (video.paused) { video.controls = true; video.play().catch(() => {}); } else video.pause(); });
  });
  root.querySelectorAll('[role="button"]').forEach(button => button.addEventListener('click', e => {
    e.stopPropagation();
    if (button.getAttribute('aria-label') === 'Play') {
      let parent = button.parentElement;
      while (parent && !parent.querySelector('video')) parent = parent.parentElement;
      const video = parent?.querySelector('video');
      if (!video) return;
      video.closest('[data-replo-carousel]')?.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      video.controls = true;
      video.play().then(() => parent?.setAttribute('data-video-playing', 'true')).catch(() => parent?.removeAttribute('data-video-playing'));
    } else [...root.querySelectorAll('.alchemy-rte')].find(el => el.textContent.trim() === 'Reason 01')?.scrollIntoView({behavior: reduced ? 'instant' : 'smooth'});
  }));
  const section = root.querySelector('.r-1l323rh');
  if (section && !reduced && 'IntersectionObserver' in window) {
    const stats = [...section.querySelectorAll('.r-v327mh > *')].flatMap(card => {
      const el = card.querySelector('.alchemy-rte p');
      const match = el?.textContent.trim().match(/^(\d+)(.*)$/);
      return match ? [{card, el, target: Number(match[1]), suffix: match[2] || ''}] : [];
    });
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const stat = stats.find(s => s.card === entry.target);
      if (!stat) return;
      observer.unobserve(stat.card); stat.card.setAttribute('data-stat-visible', 'true');
      const start = performance.now();
      function tick(now) {
        const progress = Math.min(1, Math.max(0, (now - start) / 1400));
        stat.el.textContent = `${Math.round((1 - (1 - progress) ** 3) * stat.target)}${stat.suffix}`;
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }), {threshold: 0.25});
    stats.forEach(({card, el, suffix}) => { card.setAttribute('data-stat-pending', 'true'); el.textContent = `0${suffix}`; observer.observe(card); });
  }
})();
